// extracted by mini-css-extract-plugin
var _1 = "CrossIcon-aU_e1";
var _2 = "CrossIconContainer-nfh6n";
var _3 = "Tag-pJP8t";
export { _1 as "CrossIcon", _2 as "CrossIconContainer", _3 as "Tag" }
